import { useEffect } from 'react';

const deleteIcon = '/icons/delete.svg';
const editIcon = '/icons/edit.svg';

function Table(props) {
  const { resData, resetarDados, dispatch, hideEdit, setHideEdit, setPieData, setShowPie, setShowPieClicked, showPieClicked, setPropData, propData } = props;

  const delRes = (id) => {
    let resDataEdit = resData.filter(val => val.ano !== id);
    dispatch({ type: 'RES_DATA', payload: resDataEdit });
    dispatch({ type: 'TOGGLE_LOAD_TABLE' });
  }

  useEffect(() => {
    dispatch({ type: 'TOGGLE_LOAD_TABLE', payload: false });
  }, [dispatch]);

  if (!resData || resData.length === 0 || !resData[0].ano) {
    return (
      <div className="table-container">
        <table className="table">
          <thead className="table-header">
            <tr>
              <th className="table-cell">Ano</th>
              <th className="table-cell">Quantidade</th>
              <th className="table-cell">Editar</th>
              <th className="table-cell">Deletar</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="table-cell bg-stone-200" colSpan={4}>
                <button className="text-stone-800" onClick={resetarDados}>
                  Não foi inserido dados, <u>click <b>aqui</b> para carregar dados experimentais</u>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  } else {
    return (
      <div className="table-container">
        <table className="table">
          <thead className="table-header">
            <tr>
              <th className="table-cell">Ano</th>
              <th className="table-cell">Quantidade</th>
              <th className="table-cell">Editar</th>
              <th className="table-cell">Deletar</th>
            </tr>
          </thead>
          <tbody>
            {resData.map((data, index) => (
              <tr key={data.ano} className={(data.ano === propData?.ano && !hideEdit) ? 'table-row-edit' : (index % 2 === 0 ? 'table-row' : 'table-row-alt')}>
                <td className="table-cell">
                  <button
                    onMouseEnter={() => {
                      setPieData(data);
                      setShowPie(true);
                    }}
                    onMouseLeave={() => {
                      setShowPie(false);
                    }}
                    onClick={() => {
                      setPieData(data);
                      setShowPieClicked(!showPieClicked);
                    }}
                  >
                    {data.ano}
                  </button>
                </td>
                <td className="table-cell">{new Intl.NumberFormat('pt-BR', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2
                }).format(data.quantidade)}</td>
                <td className="table-cell">
                  <div className="flex justify-center">
                  <img className="table-edit-icon" src={editIcon} onClick={() => {
                    setHideEdit(!hideEdit);
                    setPropData(data);
                  }} alt='Editar'/>
                  </div>
                </td>
                <td className="table-cell justify-center items-center">
                  <div className="flex justify-center">
                    <img className="table-delete-icon" src={deleteIcon} onClick={() => delRes(data.ano)} alt='Deletar'/>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default Table;
